import { api } from "./client";

export async function submitFeedback({ type, game, message }) {
  const res = await api.post("/feedback/", { type, game, message });
  return res.data;
}
